import DocumentManager from '@/components/documents/DocumentManager'

export default function DocumentsPage() {
  return (
    <div className="p-6 h-[calc(100vh-4rem)] flex flex-col">
      <div className="mb-5 shrink-0">
        <h2 className="text-xl font-bold text-gray-900">Gestión de Documentos</h2>
        <p className="text-sm text-gray-500 mt-0.5">
          PPIs, checklists, fotografías, planos y certificados del proyecto
        </p>
      </div>
      <div className="flex-1 min-h-0">
        <DocumentManager />
      </div>
    </div>
  )
}
